import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="#B6B6B8"
    viewBox="0 0 20 20"
    className={className}
  >
    <mask
      id="mask0_604_4453"
      style={{ maskType: 'alpha' }}
      width="20"
      height="20"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path d="M0 0H20V20H0z"></path>
    </mask>
    <g mask="url(#mask0_604_4453)">
      <path d="M9.958 15c.292 0 .539-.1.74-.302.201-.202.302-.448.302-.74 0-.291-.1-.538-.302-.74a1.006 1.006 0 00-.74-.301c-.291 0-.538.1-.74.302a1.006 1.006 0 00-.301.74c0 .291.1.537.302.739.201.201.448.302.74.302zm-.75-3.208h1.542c0-.459.052-.82.156-1.084.104-.264.4-.625.886-1.083a6.24 6.24 0 00.854-1.031c.208-.327.312-.719.312-1.177 0-.778-.284-1.375-.854-1.792-.57-.417-1.243-.625-2.02-.625-.792 0-1.435.208-1.928.625a3.307 3.307 0 00-1.03 1.5l1.374.542c.07-.25.226-.521.469-.813.243-.292.614-.437 1.114-.437.445 0 .778.121 1 .364.223.243.334.51.334.802 0 .278-.084.538-.25.782a3.35 3.35 0 01-.625.677c-.611.541-.986.951-1.125 1.229-.14.278-.209.784-.209 1.52zM10 18.333a8.115 8.115 0 01-3.25-.656 8.415 8.415 0 01-2.646-1.781 8.416 8.416 0 01-1.781-2.646A8.115 8.115 0 011.667 10c0-1.153.218-2.236.656-3.25a8.415 8.415 0 011.781-2.646A8.415 8.415 0 016.75 2.323 8.115 8.115 0 0110 1.667c1.153 0 2.236.218 3.25.656a8.415 8.415 0 012.646 1.781 8.416 8.416 0 011.781 2.646 8.115 8.115 0 01.656 3.25 8.115 8.115 0 01-.656 3.25 8.416 8.416 0 01-1.781 2.646 8.415 8.415 0 01-2.646 1.781 8.115 8.115 0 01-3.25.656zm0-1.666c1.861 0 3.438-.646 4.73-1.938 1.29-1.291 1.937-2.868 1.937-4.729 0-1.861-.646-3.438-1.938-4.73C13.438 3.98 11.861 3.334 10 3.334c-1.861 0-3.437.646-4.73 1.938C3.98 6.562 3.334 8.139 3.334 10c0 1.861.646 3.438 1.938 4.73 1.292 1.29 2.868 1.937 4.73 1.937z"></path>
    </g>
  </svg>
);

export default Icon;
